import { useState } from 'react'
import { Text, useMainContext } from '../../../modules/staking'
import { useQueryContext } from '../../../core/contexts/query'
import FilterLayout from '../../layouts/FilterLayout'
import { Column, Row } from '../../../styles/TableStyle'
import { FlexCenter } from '../../../styles/CommonStyles'
import { SOCKET_URL } from '../../../core/constants/urls'
import { Market, TextWithMargin } from '../../../styles/OrdersStyle'
import TruncateMiddle from '../../common/TruncateMiddle'
import { formatDate, formatNumber } from '../../../core/utils/common'
import { DetailsIcon } from '../../../styles/TransactionHistoryStyles'
import ModalLayout from '../../layouts/ModalLayout'
import { useTransfers } from '../../../core/hooks/useTransfers'
import { useProfileQuery } from '../../../core/services/react-query/useInternalTransfer'


const initialModalState = { show: false, data: null }

export const TransfersHistoryTable = ({ data, profileId }) => {
    const [modal, setModal] = useState(initialModalState)

    const { data: profile, isLoading: profileLoading } = useProfileQuery()

    const {
        filteredTransfers,
        transfersQueries,
        setTransfersQueries,
        transfersInitialState,
        transfersLoading,
    } = useTransfers()

    const {
        main: { lang },
    } = useMainContext()

    const { setToast } = useQueryContext()

    const onCopyToClipboard = (value) => {
        navigator.clipboard.writeText(value)
        setToast({
            show: true,
            message: 'copy-success',
        })
    }

    return (
        <>
            <FilterLayout
                headers={[
                    { title: 'coin', width: 'w-[12%]' },
                    { title: 'transfer-type', width: 'w-[13%]' },
                    { title: 'id', width: 'w-[18%]' },
                    { title: 'date-time', width: 'w-[25%]' },
                    { title: 'amount', width: 'w-[15%]' },
                ]}
                data={filteredTransfers}
                totalPages={filteredTransfers?.meta.total}
                hasCoinOption={true}
                isCurrency={true}
                noDataTop={'200px'}
                state={{
                    filterQueries: transfersQueries,
                    setFilterQueries: setTransfersQueries,
                    initialState: transfersInitialState,
                }}
                loading={profileLoading || transfersLoading}
            >
                {filteredTransfers?.data?.map((item) => {
                    const isToman = item.currency === 'irt'
                    const isReceiver = profile?._id === item?.toId

                    return (
                        <Row
                            key={item._id}
                        >
                            {/* Coin */}
                            <Column className='w-[12%]'>
                                <FlexCenter>
                                    <img
                                        src={
                                            isToman
                                                ? require('../../../assets/images/tooman.png')
                                                : SOCKET_URL + `assets/icon/${item.currency}.png`
                                        }
                                        alt={item.currency}
                                        className='w-6 h-6'
                                    />
                                    <Market>{item.currency.toUpperCase()}</Market>
                                </FlexCenter>
                            </Column>

                            {/* Type */}
                            <Column className='w-[13%]'>
                                <FlexCenter>
                                    <TextWithMargin type={isReceiver ? 'receive' : 'send'}>
                                        {isReceiver ? <Text tid='receive' /> : <Text tid='send' />}
                                    </TextWithMargin>
                                </FlexCenter>
                            </Column>

                            {/* ID */}
                            <Column className='w-[18%]'>
                                <TruncateMiddle
                                    text={item._id}
                                    frontChars={6}
                                    backChars={6}
                                    onClick={onCopyToClipboard.bind(null, item._id)}
                                />
                            </Column>

                            {/* Time/Date */}
                            <Column className='w-[25%]'>
                                {formatDate(item.createdAt, 'date', lang === 'en' ? 'en-US' : 'fa-IR')}
                                {' • '}
                                {formatDate(item.createdAt, 'time', lang === 'en' ? 'en-US' : 'fa-IR')}
                            </Column>

                            {/* Amount */}
                            <Column number className='w-[15%]'>
                                {item.amount ? formatNumber(item.amount) : '--'}
                            </Column>

                        </Row>
                    )
                })}
            </FilterLayout>

        </>
    )
}
